export enum SelectedNotesTab {
    Notes = 'notes',
    Clinical = 'clinical',
    LabReports = 'labReports',
    Encounters = 'encounters'
}